export default "__VITE_ASSET__p9T$u$KO__"